module.exports = __webpack_public_path__ + "files/a4f2e9f2207d231d73105934962f68f8.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/arvo-bolditalic-webfont.woff
 ** module id = 888
 ** module chunks = 0
 **/